<div class="receipt-template-editor" *ngIf="template">
  <div class="editor-header">
    <div class="editor-title">
      <h1>{{isNew ? 'New Receipt Template' : template.name}}</h1>
      <span class="key-badge" *ngIf="template.key">{{template.key}}</span>
      <span class="default-badge" *ngIf="template.isDefault">Default</span>
      <span class="inactive-badge" *ngIf="template.active === false">Inactive</span>
    </div>
    <div class="editor-actions">
      <button class="button red" *ngIf="!isNew && template.active !== false" (click)="deactivate()">Deactivate</button>
      <button class="button" [disabled]="saving" (click)="save()">{{isNew ? 'Create Template' : 'Save Template'}}</button>
      <button class="button" (click)="close()">Close</button>
    </div>
  </div>

  <div class="editor-body">

    <div class="column general">
      <h3 class="section-title">General</h3>
      <div class="form-grid">
        <label class="wide">
          Name
          <input type="text" placeholder="template name" [(ngModel)]="template.name" />
        </label>
        <label class="wide">
          Key
          <input type="text" placeholder="auto-generated when blank" [(ngModel)]="template.key" />
        </label>
        <label class="wide">
          Description
          <input type="text" placeholder="what this template is for" [(ngModel)]="template.description" />
        </label>
      </div>
      <div class="flag-row">
        <div class="flag">
          <app-toggle [checked]="template.isDefault === true" (valueChanged)="template.isDefault = $event"></app-toggle>
          <span>Default for locations without a template</span>
        </div>
      </div>
      <p class="hint">Receipts print {{template.width}} characters wide in a fixed-width font. Longer lines wrap on paper.</p>

      <h3 class="section-title">Locations</h3>
      <p class="hint" *ngIf="isNew">Create the template first, then choose which locations print with it.</p>
      <p class="hint" *ngIf="!isNew && locations.length === 0">No active retail locations.</p>
      <div class="row-list" *ngIf="!isNew">
        <div class="row-item location" *ngFor="let location of locations">
          <input type="checkbox" [checked]="usesThisTemplate(location)" [disabled]="assigning[location._id]"
                 (change)="toggleLocation(location, $event.target.checked)" />
          <div class="location-name">{{location.name}}</div>
          <div class="location-template">{{location.printTemplateKey || 'default'}}</div>
        </div>
      </div>

      <div class="section-header">
        <h3>Reference</h3>
        <button class="button small" (click)="showReference = !showReference">{{showReference ? 'Hide' : 'Show'}}</button>
      </div>
      <div class="reference" *ngIf="showReference">
        <p class="hint">
          <code>&lt;%= value %&gt;</code> prints a value. <code>&lt;% code -%&gt;</code> runs JavaScript; the trailing
          <code>-%&gt;</code> swallows the line break so logic lines leave no blank lines. <code>&lt;%# comment -%&gt;</code>.
        </p>
        <h4>Data</h4>
        <div class="ref-row" *ngFor="let item of referenceData">
          <code>{{item.path}}</code>
          <span>{{item.note}}</span>
        </div>
        <h4>Helpers</h4>
        <div class="ref-row" *ngFor="let item of referenceHelpers">
          <code>{{item.sig}}</code>
          <span>{{item.note}}</span>
        </div>
      </div>
    </div>

    <div class="column source">
      <div class="section-header">
        <h3>Template</h3>
        <button class="button small" (click)="resetToBuiltIn()">Reset to built-in</button>
      </div>
      <textarea class="ejs-editor" spellcheck="false" autocapitalize="off" autocomplete="off"
                [(ngModel)]="template.ejs" (ngModelChange)="templateChanged()" (keydown)="onEditorKeydown($event)"></textarea>
    </div>

    <div class="column preview">
      <div class="section-header">
        <h3>Preview</h3>
        <span class="hint" *ngIf="previewLoading">loading…</span>
      </div>
      <div class="preview-controls">
        <label>
          Location
          <select [(ngModel)]="previewLocationId" (ngModelChange)="onPreviewLocationChanged()">
            <option *ngFor="let location of locations" [value]="location._id">{{location.name}}</option>
          </select>
        </label>
        <label>
          Sample purchase
          <select [(ngModel)]="previewPurchaseId" (ngModelChange)="loadPreviewData()">
            <option *ngFor="let purchase of previewPurchases" [value]="purchase._id">
              {{purchase.key}} · {{purchase.timeUpdated | rf: 'dateTime'}} · {{purchase.total | rf: 'currency'}}<ng-container *ngIf="purchase.customerName"> · {{purchase.customerName}}</ng-container>
            </option>
          </select>
        </label>
      </div>
      <p class="hint" *ngIf="activeTemplateNote">{{activeTemplateNote}}</p>
      <div class="preview-error" *ngIf="previewError"><pre>{{previewError}}</pre></div>
      <div class="paper" *ngIf="!previewError">
        <div class="ruler">{{ruler}}</div>
        <pre class="receipt"><ng-container *ngFor="let line of previewLines"><span [class.too-long]="line.tooLong">{{line.text}}</span>
</ng-container></pre>
      </div>
      <p class="hint">Rendered here exactly as a register renders it, from {{previewPurchaseLabel || 'a sample purchase'}}. Red lines are wider than the paper and will wrap.</p>
    </div>

  </div>
</div>
